<script lang="ts" setup>
import MList from "../../../components/medicus/MList";
import { ref, onMounted, onUnmounted } from "vue";
import { QBtn } from "quasar";
import { useOnOutsidePress } from "vue-composable";
import { MenuItem, MenuItems } from "./_types";
import SidebarMenuItem from "./SidebarMenuItem";
import MLayoutStack from "../../../components/medicus/MLayoutStack";
import MItem from "../../../components/medicus/MItem";
import MSeparator from "../../../components/medicus/MSeparator";
import { useFocusTrap } from "../../../composables/useFocusTrap";

defineProps<{
  title: string;
  items: MenuItems;
  additionalInfo?: MenuItem[];
}>();

const emit = defineEmits({
  close: () => true,
});

defineExpose({
  close,
});

function handleKeyDown(event: KeyboardEvent) {
  if (event.key === "Escape") {
    close();
  }
}

const menuEl = ref<HTMLDivElement | null>(null);
function close() {
  emit("close");
}
useOnOutsidePress(menuEl, close);

useFocusTrap(menuEl, true, true);

onMounted(() => {
  window.addEventListener("keydown", handleKeyDown);
});

onUnmounted(() => {
  window.removeEventListener("keydown", handleKeyDown);
});
</script>
<template>
  <div ref="menuEl" class="sidebar-menu">
    <h1>{{ title }}</h1>

    <q-btn
      class="sidebar-menu--exit-btn rotate-180"
      icon="fa-regular fa-arrow-right-from-bracket"
      flat
      dense
      tabindex="0"
      @click="close"
    />
    <m-list class="top-sidebar-menu">
      <template v-for="(item, i) in items" :key="`sidebar-menu-${item.label}`">
        <m-separator v-if="i > 0" />

        <sidebar-menu-item :item="item" />
      </template>
    </m-list>
    <m-list v-if="additionalInfo" class="sidebar-additional-info">
      <template v-for="(info, i) in additionalInfo" :key="`additional-info-${i}`">
        <m-separator />
        <m-item tabindex="-1">
          <m-layout-stack>
            <b>{{ info.label }}</b>
            <div>{{ info.value }}</div>
          </m-layout-stack>
        </m-item>
      </template>
    </m-list>
  </div>
</template>
<style lang="scss">
.sidebar-menu {
  height: 100%;
  width: 100%;

  position: relative;

  display: flex;
  flex-direction: column;

  padding-top: 5px;

  > h1 {
    // margin-left: 15px;
    padding: 10px 10px 0 25px;
  }

  // overflow: auto;

  .m-list {
    overflow: auto;
    padding: 10px;
  }
  .m-separator {
    margin: 5px;
  }

  .m-item {
    min-height: 35px !important;
  }

  .sidebar-menu--exit-btn {
    position: absolute;
    right: 20px;
    font-size: 20px !important;
    color: var(--grey-darker);
  }

  .top-sidebar-menu {
    flex: 1;
  }
  .sidebar-additional-info {
    pointer-events: none;
  }
}
</style>
